export enum CustomListFieldTypes {
    Unspecified = 0,
    FirstName = 1,
    LastName = 2,
    Email = 3,
    Phone = 4,
    EmailNotification = 5
}